
import * as FileSaver from 'file-saver';

export default class ReceiptsDetailsController {

    constructor (
        $filter,
        $state,
        $window,
        $timeout,
        Receipt,
        brand,
        stores,
        selectedStore,
        endDate,
        startDate,
        offset,
        receiptsDetailsLoader,
        receiptsDetails,
        receiptsDetailsForExport
    ) {
        this.translate     = $filter('translate');
        this.$state        = $state;
        this.$window       = $window;
        this.$timeout      = $timeout;
        this.Receipt       = Receipt;
        this.brand         = brand;
        this.stores        = stores;
        this.selectedStore = selectedStore;
        this.endDate       = endDate;
        this.startDate     = startDate;
        this.receiptsDetailsLoader = receiptsDetailsLoader;
        this.pageNumber = (offset/10 + 1);
        this.offset = offset;
        this.count = receiptsDetails.count;
        this.receiptsDetailsForExport = receiptsDetailsForExport

        this.setReceiptsDetails(receiptsDetails);
    }

    setReceiptsDetails (receiptsDetails) {
        this.filteredReceiptsDetails = receiptsDetails.receiptsDetails;
    }

    updateFilters () {
        this.offset = 0;
        this.pageNumber = 1;

        this.getMoreReceiptsDetails();
    }

    changePage() {
        this.offset = 10*(this.pageNumber-1);
        this.getMoreReceiptsDetails();
    }

    getMoreReceiptsDetails() {
        this.$state.transitionTo(this.$state.current.name, {
            stores:    (this.selectedStore) ? this.selectedStore.id : undefined,
            startDate: (this.startDate) ? this.startDate : undefined,
            endDate:   (this.endDate) ? this.endDate : undefined,
            offset:    this.offset
        }, {reload: false});
    }

    openReceipt (receiptsDetails) {
        swal({
            title: '',
            text: '<iframe'
                 +' style="display: block; border: 0; width: 100%; height: 60vh;"'
                 +' src="https://web.mangooid.com/pdf-viewer.html?link='+encodeURIComponent(receiptsDetails.receiptUrl)+'"'
                 +'></iframe>',
            html: true,
        });
    }

    downloadList() {
      fetch('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;base64,' + this.receiptsDetailsForExport.file)
      .then(res => res.blob())
      .then(blob => FileSaver.saveAs(blob, `tickets_caisse_list_${this.startDate}_${this.endDate}.xlsx`));
    }

}

ReceiptsDetailsController.$inject = [
    '$filter',
    '$state',
    '$window',
    '$timeout',
    'Receipt',
    'brand',
    'stores',
    'selectedStore',
    'endDate',
    'startDate',
    'offset',
    'receiptsDetailsLoader',
    'receiptsDetails',
    'receiptsDetailsForExport'
];



// WEBPACK FOOTER //
// ./src/page/receiptsDetails/receiptsDetails.controller.js